import fetch from '../fetch'
import BaseApi from './BaseApi'
import FileSaver from 'file-saver'

class BaseFileApi extends BaseApi {

  get downloadFileHeaders () {
    const headers = {
      Accept: 'application/octet-stream',
      'Content-Type': 'application/octet-stream',
      'Cache-Control': 'no-store, no-cache'
    }

    return this.addAuthHeaders(headers)
  }

  get uploadFileHeaders () {
    const headers = {
      // 'Content-Type': 'multipart/form-data',
      'Cache-Control': 'no-store, no-cache'
    }
    return this.addAuthHeaders(headers)
  }

  handleFileResponse (response, fileName) {
    if (!response.ok) {
      return Promise.reject(new Error(`File download failed: ${response.status} ${response.statusText}`))
    }

    const promise = response.blob()

    promise.then((blob) => {
      FileSaver.saveAs(blob, fileName)
    })

    return promise
  }

  downloadFile (partialUrl) {
    const fullUrl = `${this.baseApiUrl}${partialUrl}`

    const promise = fetch(fullUrl, {
      method: 'GET',
      headers: this.downloadFileHeaders
    })

    promise
      .then(this.checkStatus)
      .catch(this.handleError)

    return promise
  }

  uploadFile (partialUrl, file) {
    const fullUrl = `${this.baseApiUrl}${partialUrl}`
    const data = new global.FormData()
    data.append('uploadedFile', file)

    const promise = fetch(fullUrl, {
      method: 'POST',
      headers: this.uploadFileHeaders,
      body: data
    })

    promise
      .then(this.checkStatus)
      .catch(this.handleError)

    return promise
  }

}
export default BaseFileApi
